"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SongsQuestionModule = void 0;
const base_1 = require("./base");
const util_1 = require("./util");
class SongsQuestionModule extends base_1.SelectModule {
    constructor({ requiredMax, ...rest }) {
        super(rest);
        this._type = "SongsQuestion";
        this.requiredMax = requiredMax;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        var _a;
        if (this.validate()) {
            const builderConfig = {
                actionRequired: this.actionRequired,
                id: this.id,
                label: this.label,
                // albums
                options: (_a = this.options) === null || _a === void 0 ? void 0 : _a.map((album) => {
                    var _a;
                    const albumBase = {
                        id: album.id || (0, util_1.generateUUID)(),
                        label: album.label,
                        src: album.src,
                        hidden: !!album.hidden,
                        // songs
                        options: (_a = album.options) === null || _a === void 0 ? void 0 : _a.map((song) => {
                            const songBase = {
                                id: song.id,
                                label: song.label,
                                src: song.src,
                                hidden: !!song.hidden,
                            };
                            if (song.altLabel) {
                                songBase.altLabel = song.altLabel;
                            }
                            return songBase;
                        }),
                    };
                    if (album.altLabel) {
                        albumBase.altLabel = album.altLabel;
                    }
                    return albumBase;
                }),
                type: this.type,
                required: this.required,
            };
            if (this.requiredMax) {
                builderConfig.requiredMax = this.requiredMax;
            }
            return builderConfig;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        var _a;
        const { label, requiredMax, ...base } = this.toBuilderConfig();
        const surveyConfigModule = {
            ...base,
            actionRequired: this.actionRequired,
            header: { children: (_a = label[this.languageCode]) !== null && _a !== void 0 ? _a : "" },
            options: this.options.map((album) => {
                var _a, _b, _c, _d, _e;
                return ({
                    id: album.id || (0, util_1.generateUUID)(),
                    src: (_a = album.src) === null || _a === void 0 ? void 0 : _a[this.languageCode],
                    hidden: !!album.hidden,
                    label: (_c = (_b = album.altLabel) === null || _b === void 0 ? void 0 : _b[this.languageCode]) !== null && _c !== void 0 ? _c : (_d = album.label) === null || _d === void 0 ? void 0 : _d[this.languageCode],
                    options: (_e = album.options) === null || _e === void 0 ? void 0 : _e.map((track) => {
                        var _a, _b, _c, _d;
                        return ({
                            id: track.id || (0, util_1.generateUUID)(),
                            src: (_a = track.src) === null || _a === void 0 ? void 0 : _a[this.languageCode],
                            hidden: !!track.hidden,
                            label: (_c = (_b = track.altLabel) === null || _b === void 0 ? void 0 : _b[this.languageCode]) !== null && _c !== void 0 ? _c : (_d = track.label) === null || _d === void 0 ? void 0 : _d[this.languageCode],
                        });
                    }),
                });
            }),
        };
        if (requiredMax) {
            surveyConfigModule.validation = (0, util_1.addRequiredCountValidation)({
                max: requiredMax,
            });
        }
        return surveyConfigModule;
    }
    editProps() {
        var _a, _b;
        return {
            id: this.id,
            options: this.options.map((album) => {
                var _a, _b, _c, _d, _e;
                return ({
                    id: album.id || (0, util_1.generateUUID)(),
                    label: (_b = (_a = album.altLabel) === null || _a === void 0 ? void 0 : _a[this.languageCode]) !== null && _b !== void 0 ? _b : (_c = album.label) === null || _c === void 0 ? void 0 : _c[this.languageCode],
                    src: (_d = album.src) === null || _d === void 0 ? void 0 : _d[this.languageCode],
                    hidden: !!album.hidden,
                    options: (_e = album.options) === null || _e === void 0 ? void 0 : _e.map((song) => {
                        var _a, _b, _c, _d;
                        return ({
                            id: song.id || (0, util_1.generateUUID)(),
                            label: (_b = (_a = song.altLabel) === null || _a === void 0 ? void 0 : _a[this.languageCode]) !== null && _b !== void 0 ? _b : (_c = song.label) === null || _c === void 0 ? void 0 : _c[this.languageCode],
                            src: (_d = song.src) === null || _d === void 0 ? void 0 : _d[this.languageCode],
                            hidden: !!song.hidden,
                        });
                    }),
                });
            }),
            type: this.type,
            question: (_b = (_a = this.label) === null || _a === void 0 ? void 0 : _a[this.languageCode]) !== null && _b !== void 0 ? _b : "",
            setlist: !!this.requiredMax
                ? { requiredMax: this.requiredMax }
                : undefined,
            actionRequired: this.actionRequired,
        };
    }
}
exports.SongsQuestionModule = SongsQuestionModule;
//# sourceMappingURL=SongsQuestion.js.map